import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import detector from "i18next-browser-languagedetector";
import enTranslations from "./locales/en/translation.json";
import deTranslations from "./locales/de/translation.json";
import frTranslations from "./locales/fr/translation.json";
import esTranslations from "./locales/es/translation.json";
import jaTranslations from "./locales/ja/translation.json";
import uaTranslations from "./locales/ua/translation.json";
import zhCNTranslations from "./locales/zh-CN/translation.json";

const resources = {
    en: { translation: enTranslations },
    de: { translation: deTranslations },
    fr: { translation: frTranslations },
    es: { translation: esTranslations },
    ja: { translation: jaTranslations },
    ua: { translation: uaTranslations },
    "zh-CN": { translation: zhCNTranslations },
};

i18n
  .use(initReactI18next)
  .use(detector)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    defaultNS: 'translation',
    ns: ['translation'],
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage'],
      caches: ['cookie', 'localStorage'],
    },
  });

export default i18n;